export default "__VITE_ASSET__0anNs_Iz__"